import React, { Fragment } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { YmmeSelectors, VehicleConfiguratorStyles } from 'src/components/VehicleConfigurator'
import VehicleEditorButtons from '../../../VehicleEditorButtons'

const { ErrorBanner } = VehicleConfiguratorStyles

const YMMEEditor = ({
  handleSubmit,
  handleSwitch,
  ymmeError,
  userVehicleDetails: {
    editVehicle
  } = {},
  userVehicleDetails,
  ...props
}) =>
  <Fragment>
    {
      ymmeError &&
        <ErrorBanner error_alternative>{ ymmeError }</ErrorBanner>
    }
    <YmmeSelectors { ...props } userVehicleDetails={ userVehicleDetails } />
    <ButtonsWrapper>
      <VehicleEditorButtons handleUpdate={ handleSubmit } editVehicle={ editVehicle } />
    </ButtonsWrapper>
  </Fragment>

export default YMMEEditor

YMMEEditor.propTypes = {
  handleSubmit: PropTypes.func,
  handleSwitch: PropTypes.func,
  userVehicleDetails: PropTypes.shape({
    editVehicle: PropTypes.bool
  }),
  ymmeError: PropTypes.string
}

const ButtonsWrapper = styled.div`
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
`
